export const read_sass_offer_registration_id = (offerItem = {}) => {
    return `${offerItem?.offerId || offerItem?.registrationId || offerItem?.connection?.links?.godfather?.registrationId || offerItem?._id || ''}`;
};
